import doc                                   from '@widesk-core/decorators/doc';
import model                                 from '@widesk-core/decorators/model';
import AccountServiceModel                   from '@/models/AccountServiceModel';
import TimestampAble                         from '@widesk-core/models/traits/TimestampAble';
import Blamable                              from '@/models/traits/Blamable';
import AccountSubscriptionModel              from '@models/account/AccountSubscriptionModel';
import SubscriptionModel                     from '@models/account/SubscriptionModel';

// Les ids des statuts sont fixés par les fixtures du back, comme pour les autres statuts de ce
// service. On filtre sur l'id parce que l'API n'offre pas de filtre sur la référence textuelle
// (« PENDING », « APPLIED »…).
export enum RequestChangeSubscriptionStatusId {
	pending = '1',
	processing = '2',
	applied = '3',
	cancelled = '4',
}

/**
 * Les deux statuts d'une demande qui peut encore aboutir : PENDING (elle attend l'échéance de la
 * période en cours) et PROCESSING (son paiement est en cours chez le prestataire). Une demande
 * déjà appliquée ou annulée n'a plus rien à annoncer au client.
 */
export const OPEN_REQUEST_STATUS_IDS = [
	RequestChangeSubscriptionStatusId.pending,
	RequestChangeSubscriptionStatusId.processing,
];

@model.urnResource('request_change_subscription')
@doc.path('/request_change_subscriptions/{?id}')
export default class RequestChangeSubscriptionModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'accountSubscription': id;
		'fromSubscription': id;
		'id': id;
		'requestChangeSubscriptionStatus': id | id[];
		'toSubscription': id;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.date declare appliedAt: Dayjs;
	@doc.date declare scheduledAt: Dayjs;
	@doc.model(AccountSubscriptionModel) declare accountSubscription: AccountSubscriptionModel;
	@doc.model(SubscriptionModel) declare fromSubscription: SubscriptionModel;
	@doc.model(SubscriptionModel) declare toSubscription: SubscriptionModel;

	public get statusReference(): Account_RequestChangeSubscriptionStatusReference | undefined {
		return this.get('requestChangeSubscriptionStatus.reference');
	}
}
